import { useState, useRef } from "react"
import PropTypes from "prop-types"

import CustomField from "./custom_field"
import ErrorReader from "../static_applet_composer/lib/error_reader"

import { arrayAdd, arrayRemove, arrayReplace } from "shared/lib/utils"
import { customFieldShape } from "partners/components/shared/shared_prop_types"

import styles from "./applet_configuration.module.scss"

const CustomFields = ({
  customFields,
  customFieldNames,
  onCustomFieldsChange,
  disabled,
  errors,
  configUI,
}) => {
  const [dupeKeyNameWarning, updateDupeKeyNameWarning] = useState("")
  const [addButtonDisableStatus, updateAddButtonDisableStatus] = useState(false)

  const handleCustomFieldAddClick = e => {
    e.preventDefault()

    onCustomFieldsChange(
      arrayAdd(customFields, {
        id: null,
        name: "",
        label: "",
        fieldUiType: "text_field",
        required: false,
        collapsed: false,
      })
    )

    updateAddButtonDisableStatus(true)
  }

  const handleCustomFieldRemove = index => {
    return () => onCustomFieldsChange(arrayRemove(customFields, index))
  }

  const handleCustomFieldChange = index => {
    return updatedCustomField => {
      onCustomFieldsChange(
        arrayReplace(customFields, index, updatedCustomField)
      )
    }
  }

  const checkIfKeyNameIsDupe = name => {
    updateDupeKeyNameWarning(
      customFieldNames.filter(value => value === name).length > 1
        ? "Key names have to be unique per connection"
        : ""
    )
  }

  const optionButtonRef = useRef(null)

  return configUI ? (
    <>
      <div className={`${styles["left-button"]} ${styles["align-left"]}`}>
        <button
          className="button-tertiary button-outlined"
          onClick={handleCustomFieldAddClick}
          ref={optionButtonRef}
          disabled={addButtonDisableStatus}
        >
          Add option
        </button>
      </div>
      {customFields.length > 0 && (
        <div className="fieldset composer-fieldset">
          {customFields.map((cf, i) => {
            const fieldErrors = errors.select(`custom_fields/${i}`)
            return (
              <CustomField
                key={i}
                index={i}
                customField={cf}
                disabled={disabled}
                onCustomFieldChange={handleCustomFieldChange(i)}
                onCustomFieldRemove={handleCustomFieldRemove(i)}
                validateNameUniqueness={checkIfKeyNameIsDupe}
                dupeKeyNameWarning={dupeKeyNameWarning}
                errors={fieldErrors}
                configUI={configUI}
                refToScroll={optionButtonRef}
                updateAddButtonDisableStatus={updateAddButtonDisableStatus}
              />
            )
          })}
        </div>
      )}
    </>
  ) : (
    <div className="fieldset composer-fieldset">
      <h3>Connection fields</h3>

      {customFields.map((cf, i) => {
        const fieldErrors = new ErrorReader(errors).select(`custom_fields/${i}`)
        return (
          <CustomField
            key={i}
            index={i}
            customField={cf}
            disabled={disabled}
            onCustomFieldChange={handleCustomFieldChange(i)}
            onCustomFieldRemove={handleCustomFieldRemove(i)}
            validateNameUniqueness={checkIfKeyNameIsDupe}
            dupeKeyNameWarning={dupeKeyNameWarning}
            errors={fieldErrors}
          />
        )
      })}

      <button
        className="button-tertiary"
        disabled={disabled}
        onClick={handleCustomFieldAddClick}
      >
        Add connection field
      </button>
    </div>
  )
}

CustomFields.propTypes = {
  customFields: PropTypes.arrayOf(customFieldShape).isRequired,
  onCustomFieldsChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  configUI: PropTypes.bool,
}

CustomFields.defaultProps = {
  configUI: false,
}
export default CustomFields
